import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito conocimientos previos en cejas o pestañas para hacer el curso?',
  answer: '¡Para nada! El programa está diseñado desde cero. Te enseñamos desde la teoría básica hasta la técnica avanzada paso a paso. No importa si nunca tocaste una pinza, vas a salir lista para atender tus primeras clientas.'
}, {
  question: '¿Qué materiales necesito para empezar y dónde los consigo?',
  answer: 'Necesitás un kit básico de extensiones de cejas (pelos, adhesivo específico, pinzas y preparadores). Dentro del curso te damos la lista completa de materiales y los proveedores recomendados en Argentina para que compres con seguridad y al mejor precio.'
}, {
  question: '¿Cuánto tiempo duran las extensiones de cejas en la clienta?',
  answer: 'La duración varía entre 2 a 3 semanas dependiendo del cuidado de la clienta y el tipo de piel. Es el servicio ideal para generar mantenimientos recurrentes y tener clientas fijas todos los meses en tu gabinete.'
}, {
  question: '¿Es una técnica difícil de aprender de forma online?',
  answer: '¡Al contrario! Es mucho mejor que en un curso presencial donde a veces no llegás a ver bien la mano de la instructora. Podés ver cada clase las veces que necesites.'
}, {
  question: '¿Cuánto puedo cobrar por este servicio en Argentina?',
  answer: 'Hoy un servicio de Brow Extensions se está cobrando entre $35.000 y $60.000 dependiendo de tu zona. Al ser una técnica nueva y exclusiva, podés posicionarte con un precio premium y recuperar tu inversión con solo 1 o 2 clientas.'
}, {
  question: '¿El curso incluye certificado?',
  answer: 'Sí, al finalizar vas a poder descargar tu certificado de Luxury Brow Extensions.'
}, {
  question: '¿Tengo acceso de por vida o vence en algún momento?',
  answer: 'El acceso es de por vida. Podés ver las clases hoy, en un mes o en un año. También vas a tener acceso a todas las actualizaciones futuras que hagamos del programa sin pagar ni un peso extra.'
}, {
  question: '¿Cómo recibo el acceso al programa una vez que pago?',
  answer: 'El acceso es inmediato. Una vez que se acredita el pago (por Mercado Pago es al instante), te llega un mail automático con tus datos de acceso a la plataforma para que empieces a estudiar ahora mismo.'
}, {
  question: '¿Qué pasa si tengo dudas durante el proceso?',
  answer: 'No vas a estar sola. Debajo de cada clase tenés un sector de comentarios donde podés dejar tus dudas y nuestro equipo técnico te va a responder para que no te quedes trabada en ningún paso.'
}, {
  question: 'Me da miedo que no sea lo que busco... ¿tienen garantía?',
  answer: '¡Cero riesgo para vos! Tenés una garantía incondicional de 7 días. Si entrás, ves el contenido y sentís que no es para vos, pedís la devolución y te reintegramos el 100% de tu dinero sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-20 px-4 bg-[#121212] pt-[0px] pb-[0px]" data-id="element-46" data-mp="1f5kgaqid6tc0">
      <div className="max-w-3xl mx-auto" data-id="element-47" data-mp="1f7ovi4lprerl">
        <div className="text-center mb-12" data-id="element-48" data-mp="1b3h4u1vp3oqq">
          <h2 className="text-3xl md:text-5xl font-black leading-tight text-[#FFFFFF] pt-[20px] pb-[20px]" data-id="element-49" data-mp="1b490tdt7fohj">
            ❓LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-50" data-mp="22u3pr9d5hc5o">
          {faqs.map((faq, index) => <div key={index} className="bg-[#000000] rounded-xl border border-gray-700 overflow-hidden shadow-sm" data-id="element-51" data-mp="1yttk5xt9snrc" data-mpi={index}>
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left gap-4 hover:bg-[#1a1a1a] transition-colors bg-[#000000]" data-id="element-52" data-mp="1u2bmbimjn3al">
                <span className="text-base md:text-lg font-[500] font-[Inter,_sans-serif] text-[#FFFFFF]" data-id="element-53" data-mp="2miw09189a8jq">
                  {index + 1}. {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#9C16A3] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-54" data-mp="2hqcpsd4v7tj5" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 bg-[#000000] ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-55" data-mp="26db09taldfct">
                <p className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-56" data-mp="1xccsczx18noy">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}